import {
  earlyAccessFacilitiesContract,
  type EarlyAccessFacilitiesResponse,
  type EarlyAccessFacilityDto,
} from "@clipboard-health/contract-backend-main";

/**
 * Response schema from contract package for API validation
 */
// eslint-disable-next-line prefer-destructuring
export const earlyAccessFacilitiesResponseSchema =
  earlyAccessFacilitiesContract.listEarlyAccessFacilities.responses[200];

export interface Facility {
  id: string;
  name: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  lat: number;
  lng: number;
}

export type FacilityWithDistance = Facility & {
  distance?: number;
};

/**
 * Transform API response to UI-friendly format
 * GeoJSON coordinates are [longitude, latitude], so we swap them
 */
export function transformFacilityDto(dto: EarlyAccessFacilityDto): Facility {
  const [lng, lat] = dto.attributes.geoLocation.coordinates;

  return {
    id: dto.id,
    name: dto.attributes.name,
    address: dto.attributes.address.line1,
    city: dto.attributes.address.city,
    state: dto.attributes.address.stateCode,
    zipCode: dto.attributes.address.postalCode,
    lat,
    lng,
  };
}

export function transformFacilitiesResponse(response: EarlyAccessFacilitiesResponse): Facility[] {
  return response.data.map(transformFacilityDto);
}
